/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeleteOAuthAppForPooledOrgOperationStatus { 
    total_apps_to_be_deleted?: Array<string>;
    successfully_deleted?: Array<string>;
    failed_to_delete?: Array<string>;
}

